import { Select } from 'antd'

import Styled from './styled'

export default function MySelect(props) {
  const selectProps = {
    allowClear: true,
    dropdownMatchSelectWidth: false,
    showSearch: true,
    filterOption: (input, option) => {
      return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    style: { minWidth: 100 },
    ...props,
  }

  return (
    <Styled className="select-component">
      <Select {...selectProps} />
    </Styled>
  )
}
